// StockCountCopyDialog.js
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { translator } from "../../utils/Translator";
import axios from "axios";
import CircularProgress from "@material-ui/core/CircularProgress";
import moment from "moment";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";

const StockCountCopyDialog = ({ open, onClose, onConfirm, data }) => {
  const { authUser } = useSelector(({ auth }) => auth);
  const { translate } = useSelector(({ i18n }) => i18n);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // ฟังก์ชัน clearCachedDocNumber
  const clearCachedDocNumber = () => {
    const salesmanKey = authUser?.salesman || authUser?.username || "DEFAULT";
    const company = authUser?.company || "DEFAULT";
    const cacheKey = `stockcount_doc_number_${company}_${salesmanKey}`;

    try {
      localStorage.removeItem(cacheKey);
    } catch (e) {
      console.warn("Error clearing cached doc number:", e);
    }
  };

  if (!open || !data) return null;

  const handleConfirm = async () => {
    setLoading(true);
    setError("");

    try {
      // ขั้นตอนที่ 1: เรียก API 'genarateDocNumber' เพื่อขอเลขเอกสารใหม่
      const genNumResponse = await axios.get(
        `${process.env.REACT_APP_API_URL}CustomerAccount/genarateDocNumber`,
        {
          params: {
            company: authUser?.company || "DEFAULT",
            documentType: "stockcount",
            salesmanCode: authUser?.salesman || authUser?.username || "DEFAULT",
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("x-access-token")}`,
          },
        }
      );

      const newDocNumber = genNumResponse.data?.data?.docNumber;

      if (!newDocNumber) {
        throw new Error(
          translator(
            translate.ISA_CannotGenerateNewDocumentNumber,
            "ไม่สามารถสร้างเลขเอกสารใหม่ได้จาก API"
          )
        );
      }

      // ขั้นตอนที่ 2: ดึงข้อมูลเอกสารต้นฉบับ
      const originalDocResponse = await axios.get(
        `${process.env.REACT_APP_API_URL}stockcount/getStockCountTransactionByDocNo/${data.docNo}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("x-access-token")}`,
          },
        }
      );

      const originalDoc = originalDocResponse.data?.data;



      if (!originalDoc) {
        throw new Error(
          translator(
            translate.ISA_CannotLoadOriginalDocument,
            "ไม่สามารถดึงข้อมูลเอกสารต้นฉบับได้"
          )
        );
      }

      // ขั้นตอนที่ 3: เตรียมข้อมูลเอกสารใหม่

      const timestamp = moment().format("YYYY-MM-DD HH:mm:ss");
      const newDocDate = moment().format("YYYY-MM-DD");

      const newDocumentData = {
        company: authUser?.company || "DEFAULT",
        SalesmanCode: authUser?.salesman || authUser?.username || "DEFAULT",
        SalesmanName: authUser?.displayName || authUser?.username || "SYSTEM",
        CustomerCode:
          originalDoc?.header?.CustomerCode ||
          originalDoc?.CustomerCode ||
          data.customerCode ||
          "",
        CustomerName:
          originalDoc?.header?.CustomerName ||
          originalDoc?.CustomerName ||
          data.customer ||
          "",
        DocNumber: newDocNumber,
        DocDate: newDocDate,
        DocRefDate:
          originalDoc?.header?.DocRefDate || originalDoc?.DocRefDate
            ? moment(
                originalDoc?.header?.DocRefDate || originalDoc?.DocRefDate
              ).format("YYYY-MM-DD")
            : newDocDate,
        DocCreateTime: moment().format("YYYYMMDDHHmm"),
        DocRemark:
          originalDoc?.header?.DocRemark ||
          originalDoc?.DocRemark ||
          data.DocRemark ||
          "",
        Status: "D", // สถานะร่าง
        items: originalDoc?.items || originalDoc?.Items || [],
        isActive: 1,
      };


      // ขั้นตอนที่ 4: บันทึกรายการสินค้า (ถ้ามี)
      let itemsPayload = [];
      const items = originalDoc?.details || originalDoc?.Items || [];
      if (items && items.length > 0) {
        itemsPayload = items.map((item, index) => {

          return {
            company: authUser?.company || "DEFAULT",
            salesmanCode: authUser?.salesman || authUser?.username || "DEFAULT",
            DocNumber: newDocNumber,
            Itemnumber: index + 1,
            ProductCode: item.ProductCode || "",
            ProductName: item.ProductName || "",
            LotNo: item.lotNo || "",
            MfgDate: item.ItemMFGDate
              ? moment(item.ItemMFGDate).format("YYYY-MM-DD")
              : null,
            ExpDate: item.ItemEXPDate
              ? moment(item.ItemEXPDate).format("YYYY-MM-DD")
              : null,
            Remark: item.ItemRemark || "",
            Items: [
              {
                ProductQuan: item.ProductQuan || 0,
                unit: item.Unit || "",
              },
            ],
            isActive: 1,
          };
        });
      }

      // ขั้นตอนที่ 5: เรียก API 'create' เพื่อบันทึกเอกสารใหม่
      const createResponse = await axios.post(
        `${process.env.REACT_APP_API_URL}stockcount/copyStockTransaction`,
        newDocumentData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("x-access-token")}`,
          },
        }
      );


      if (!createResponse.data || !createResponse.data.success) {
        throw new Error(
          translator(
            translate.ISA_CopyDocumentSaveFailed,
            "API ไม่สามารถบันทึกเอกสารที่คัดลอกได้"
          )
        );
      }

      // ขั้นตอนที่ 6: บันทึกรายการสินค้า (ถ้ามี)
      if (itemsPayload.length > 0) {
        try {
          await axios.post(
            `${process.env.REACT_APP_API_URL}stockcount/createStockTransactionitem`,
            { items: itemsPayload },
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem(
                  "x-access-token"
                )}`,
              },
            }
          );
        } catch (itemError) {
          console.error("Error saving items:", itemError);
          // ไม่ throw error เพราะเอกสารหลักบันทึกสำเร็จแล้ว
        }
      }

      // Clear cache หลัง copy สำเร็จ
      clearCachedDocNumber();

      const createdDocument = createResponse.data.data;

      if (onConfirm) {
        onConfirm({
          success: true,
          newDocument: createdDocument,
          originalDocument: data,
          message: translator(
            translate.ISA_CopyDocumentSuccess,
            "คัดลอกเอกสารสำเร็จ"
          ),
          shouldRefresh: true,
        });
      }
      onClose();
    } catch (err) {
      console.error(" An error occurred during the copy process:", err);
      const errorMessage =
        err.response?.data?.message ||
        err.message ||
        translator(
          translate.ISA_CopyDocumentError,
          "เกิดข้อผิดพลาดในการคัดลอกเอกสาร"
        );

      alert(
        `${translator(
          translate.ISA_CopyDocumentError,
          "เกิดข้อผิดพลาดในการคัดลอกเอกสาร"
        )}:\n${errorMessage}`
      );

      setError(errorMessage);

      if (onConfirm) {
        onConfirm({
          success: false,
          error: errorMessage,
          originalDocument: data,
          shouldRefresh: false,
        });
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle disableTypography>
        <Typography variant="h6">
          {translator(
            translate.ISA_StockCountCopyTitle,
            "คัดลอกเอกสารนับสต็อก"
          )}
        </Typography>
        <IconButton
          onClick={onClose}
          style={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Typography gutterBottom>
          {translator(
            translate.ISA_StockCountCopyConfirm,
            "ต้องการคัดลอกเอกสารนับสต็อก รายการนี้ หรือไม่ ?"
          )}
        </Typography>
        <div
          style={{
            background: "#f8f9fa",
            padding: "16px",
            borderRadius: "6px",
            border: "1px solid #e9ecef",
          }}
        >
          <Typography
            variant="body2"
            component="div"
            style={{ marginBottom: "8px" }}
          >
            <strong>{translator(translate.ISA_DocNumber, "เลขที่เอกสาร")} : </strong>
            <span style={{ color: "#007bff" }}>{data.docNo}</span>
          </Typography>
          <Typography
            variant="body2"
            component="div"
            style={{ marginBottom: "8px" }}
          >
            <strong>{translator(translate.ISA_Salesman, "พนักงานขาย")} : </strong>
            <span style={{ color: "#28a745" }}>{data.salesman}</span>
          </Typography>
          <Typography
            variant="body2"
            component="div"
            style={{ marginBottom: "8px" }}
          >
            <strong>{translator(translate.ISA_Customer, "ลูกค้า")} : </strong>
            <span style={{ color: "#6f42c1" }}>{data.customer}</span>
          </Typography>
          <Typography
            variant="body2"
            component="div"
            style={{ marginBottom: "8px" }}
          >
            <strong>{translator(translate.ISA_StockCountDate, "วันที่นับจริง")} : </strong>
            <span style={{ color: "#dc3545", fontWeight: "bold" }}>
              {data.realDate ? moment(data.realDate).format("DD/MM/YYYY") : "-"}
            </span>
          </Typography>
          <Typography variant="body2" component="div">
            <strong>{translator(translate.ISA_Remark, "หมายเหตุ")} : </strong>
            <span>{data.DocRemark || "-"}</span>
          </Typography>
        </div>
        {error && (
          <div
            style={{
              marginTop: "16px",
              padding: "12px",
              backgroundColor: "#f8d7da",
              border: "1px solid #f5c6cb",
              borderRadius: "6px",
              color: "#721c24",
            }}
          >
            <strong>{translator(translate.ISA_Title_Error, "เกิดข้อผิดพลาด")}: </strong> {error}
          </div>
        )}
        {loading && (
          <div style={{ textAlign: "center", padding: "16px" }}>
            <CircularProgress size={30} />
            <Typography
              variant="body2"
              color="textSecondary"
              style={{ marginTop: "10px" }}
            >
              {translator(
                translate.ISA_CopyingDocument,
                "กำลังคัดลอกเอกสาร..."
              )}
            </Typography>
          </div>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary" disabled={loading}>
          {translator(translate.ISA_Cancel1, "ยกเลิก")}
        </Button>
        <Button
          onClick={handleConfirm}
          color="primary"
          variant="contained"
          disabled={loading}
        >
          {loading
            ? translator(
                translate.ISA_Processing,
                "กำลังดำเนินการ..."
              )
            : translator(translate.ISA_Confirm, "ยืนยัน")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default StockCountCopyDialog;
